export default class DtoCaptureDownstreamDistribUnit {
    constructor(obj) {
        this.idStation = obj.idStation
        this.downstreamIdStation = obj.downstreamIdStation
        this.downstreamLevel = obj.downstreamLevel
    }
}